import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import DiscountCouponsFilter from "../../components/Table Filters/SaraLadgerFilter.js";
import PermissionAccess from '../../PermissionAccess/Access.js';
import moment from "moment";
import { downloadLedgerPdf, normalizeSaraLedgerRows } from "../../utils/ledgerPdfGenerator";

const DiscountcouponsList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [discountcoupons, setDiscountcoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('');
  const [selectedId, setSelectedId] = useState('');
  const [saraTotal, setSaraTotal] = useState(0);
  const [pdfDownloading, setPdfDownloading] = useState(false);


  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();

  const [showModalAddDiscountCoupon, setShowModalAddDiscountCoupon] = useState(false);
  const handleToggleModalAddDiscountCoupon = () => {
    setShowModalAddDiscountCoupon(!showModalAddDiscountCoupon);
  }

  const [showModalEditDiscountCoupon, setShowModalEditDiscountCoupon] = useState(false);
  const handleToggleModalEditDiscountCoupon = (id) => {
    setShowModalEditDiscountCoupon(!showModalEditDiscountCoupon);
    setSelectedId(id); // Set the selected ID when toggling modal
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchDiscountcoupons(0, pageLimit);
  }, [pageLimit]);


  function fetchDiscountcoupons(page_index, page_limit, status) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    
    DiscountCouponService.getSARALadgerDetails(authData.sessionID,offset, page_limit, status).then(
      (response) => {
        setLoading(false);
        console.log("Get discountcoupons response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          console.log(response.data);
          setDiscountcoupons(response.data.data);
          setSaraTotal(response.data.saraTotal);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }



  const mycolumns = [
   {
    name: t('Date'),
    selector: row =>
      moment(row.datetime_added).format("DD MMMM YYYY, hh:mm A"),
    width: "20%",
    sortable: true,
  },

    {
    name: t('Activity'),
    cell: row => row.doctor_ladger_details?.required_action || row.from || "-",
    width: "35%",
    sortable: true,
    },

    {
        name: t('Total Transaction'),
        cell: row => {
            const amount = row.doctor_ladger_details?.total_amount ?? 0;
            return `RM ${amount.toFixed(2)}`;
        },
        width: "20%",
        sortable: true,
    },
    

    {
    name: t('Sara Share'),
    cell: row => {
        const isNegative = row.ladger_action === "-";
        const badgeClass = isNegative ? "bg-danger" : "bg-success";

        const actionSymbol = row.doctor_ladger_details?.ladger_action || "";
        const saraShare = row.doctor_ladger_details?.sara_share ?? 0;

        return (
        <span className={`badge ${badgeClass}`}>
            {actionSymbol} RM {saraShare.toFixed(2)}
        </span>
        );
    },
    width: "10%",
    sortable: true,
    },

{
    name: t('From'),
    cell: row => row?.from,
    width: "15%",
    sortable: true,
    },



  ];



  const handleSearch = (status) => {
    setFilterStatus(status);
    if (status !== '') {
      fetchDiscountcoupons(0, pageLimit, status)
    }
  };

  const handleClear = () => {
    setFilterStatus('');
    fetchDiscountcoupons(0, pageLimit);
  };
  const filteredItems = discountcoupons;


 

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <DiscountCouponsFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterStatus={filterStatus}
      />
    );
  }, [filterStatus]);


  function handlePageChange(page_index) {
    console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchDiscountcoupons(page_index, pageLimit, filterStatus);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  const handleDownloadPdf = async () => {
    setPdfDownloading(true);
    try {
      const response = await DiscountCouponService.getSARALadgerDetails(
        authData.sessionID,
        0,
        10000,
        filterStatus
      );

      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
        return;
      }

      const rows = normalizeSaraLedgerRows(response.data.data || []);
      if (!rows.length) {
        Alerts.swalErrorAlert(t("No transaction data available."));
        return;
      }

      await downloadLedgerPdf({
        data: rows,
        entityName: t("SARA Ledger"),
        ledgerType: "sara",
        fileName: `SARA_Ledger_${moment().format("YYYY-MM-DD")}.pdf`,
        t,
      });
      Alerts.swalSuccessAlert(t("PDF generated successfully"));
    } catch (error) {
      Alerts.swalErrorAlert(error.message || t("Failed to generate PDF. Please try again."));
    } finally {
      setPdfDownloading(false);
    }
  };

  return (
    <Fragment>

      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="bg-light-gray bg-animation">
            <div className="d-flex justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                      </div>
                     <div>
                      {`${t("SARA Ledger")}`}
                      <div className="page-title-subheading">
                        {`${t("Details for")} ${t("SARA Ledger")}` } 
                      </div>
                    </div>
                    </div>
                    <div className="page-title-actions">
                      <button
                        type="button"
                        className="btn btn-outline-success btn-hover-shine me-3"
                        onClick={handleDownloadPdf}
                        disabled={pdfDownloading}
                      >
                        <i className="pe-7s-download me-2" />
                        {pdfDownloading ? t("Generating PDF...") : t("Download PDF")}
                      </button>
                    </div>
                  </div>
                </div>
                <Row>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Col md="12">
                      <Card className="main-card mb-3">
                        <CardBody>
                          <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                            {subHeaderComponentMemo}
                          </Col>
                          <DataTable
                            data={filteredItems}
                            columns={mycolumns}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            subHeader
                            subHeaderComponent={
                              <div className="d-flex align-items-center gap-2">
                                <button
                                  type="button"
                                  className="btn btn-custom-color btn-hover-shine me-3 btn"
                                  onClick={handleToggleModalAddDiscountCoupon}
                                >
                                  {t('Total Amount')}: RM {(saraTotal || 0).toFixed(2)}
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-success btn-hover-shine"
                                  onClick={handleDownloadPdf}
                                  disabled={pdfDownloading}
                                >
                                  <i className="pe-7s-download me-2" />
                                  {pdfDownloading ? t("Generating PDF...") : t("Download PDF")}
                                </button>
                              </div>
                            }

                            paginationServer
                            paginationTotalRows={totalRows}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationResetDefaultPage={resetPaginationToggle}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </LoadingOverlay>
                </Row>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscountcouponsList;
